<template>
    <div v-if="form && model">
        <rkm-area no-margin-top title="filtros" type="fieldset">
            <rkm-form
                ref="RkmForm"
                show-legend
            >
                <rkm-row>
                    <rkm-col cols="2">
                        <rkm-form-date-picker
                            label="Período de"
                            v-model="model.dataInicial"
                            :validations="validations.dataInicial"
                        />
                    </rkm-col>
                    <rkm-col cols="2">
                        <rkm-form-date-picker
                            label="Até"
                            v-model="model.dataFinal"
                            :validations="validations.dataFinal"
                            :min-date="model.dataInicial"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-select
                            show-default-option
                            default-option-text="Todos"
                            :options="form.motivoViagem"
                            label="Motivo da viagem"
                            text-field="descricao"
                            value-field="id"
                            v-model="model.motivoViagem"
                            @change="getMunicipios"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-select
                            show-default-option
                            default-option-text="Todos"
                            :options="form.municipio"
                            label="Cidade de destino"
                            text-field="nome"
                            value-field="id"
                            v-model="model.municipio"
                            @change="getDestinos"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-select
                            show-default-option
                            default-option-text="Todos"
                            :options="form.destino"
                            label="Local de destino"
                            text-field="descricao"
                            value-field="id"
                            v-model="model.destino"
                            @change="getVeiculos"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-select
                            show-default-option
                            default-option-text="Todos"
                            :options="form.veiculo"
                            label="Veículo"
                            text-field="descricao"
                            value-field="id"
                            v-model="model.veiculo"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-input-autocomplete
                            :repository="repositories.paciente"
                            :search-fields="fieldsPaciente.paciente"
                            :text-field="(item) => item.cidadao.nome"
                            label="Paciente"
                            v-model="model.paciente"
                            uppercase
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-select
                            show-default-option
                            default-option-text="Todos"
                            :options="form.status"
                            label="Status"
                            text-field="descricao"
                            value-field="id"
                            v-model="model.status"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-input
                            label="Protocolo"
                            v-model="model.protocolo"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-button
                            color="primary"
                            :label="false"
                            @click="search"
                        >
                            Buscar
                        </rkm-button>
                        <rkm-button
                            :label="false"
                            @click="reset"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <rkm-area
            no-margin-top
            title="Resultado"
            v-if="notBusca"
        >
            <template v-slot:trailing>
                <rkm-dropdown
                    class="mr-2"
                    color="primary"
                    cols="1"
                    menu-class="auto-scroll"
                    no-caret
                    small
                    title="Colunas"
                    v-rkm-tooltip.hover
                >
                    <template v-slot:button-content>
                        <rkm-icon icon="columns" />
                    </template>

                    <rkm-form-checkbox
                        :indeterminate="indeterminate"
                        @change="selectAll"
                        class="mx-2"
                        v-model="selectedAll"
                    >
                        Todas
                    </rkm-form-checkbox>

                    <rkm-form-checkbox-group
                        :options="optionalColumns"
                        class="mx-2"
                        stacked
                        text-field="label"
                        v-model="selectedCols"
                        value-field="key"
                    />
                </rkm-dropdown>

                <rkm-button
                    :disabled="items.length === 0"
                    @click="print"
                    color="info"
                    small
                    title="Imprimir"
                >
                    <rkm-icon icon="print" />
                </rkm-button>

                <rkm-button
                    :disabled="items.length === 0"
                    @click="exportTo"
                    color="info"
                    small
                    title="Exportar"
                >
                    <rkm-icon icon="file-export" />
                </rkm-button>
            </template>

            <rkm-table
                :fields="fields"
                :items="items"
                no-footer-sorting
            >
                <template v-slot:cell(data)="{ item }">
                    {{ item.data | formatDate }}
                </template>

                <template v-slot:cell(cns)="{ item }">
                    {{ item.cns | formatCns }}
                </template>

                <template v-slot:cell(actions)="{ item }">

                    <rkm-button
                        color="primary"
                        small
                        title="Visualizar"
                        @click="$refs.Modal.open(item)"
                    >
                        <rkm-icon icon="search" />
                    </rkm-button>
                </template>
            </rkm-table>

            <Modal
                :data="data"
                ref="Modal"
            />
        </rkm-area>

        <rkm-area
            title="Totais"
            no-margin-top
            class="mt-2"
            v-if="notBusca && totalizadores"
        >
            <rkm-row>
                <rkm-col cols="2">
                    Paciente
                    <rkm-alert color="secondary">
                        <strong>
                            {{ totalizadores.totalPaciente }}
                        </strong>
                    </rkm-alert>
                </rkm-col>

                <rkm-col cols="2">
                    Acompanhante
                    <rkm-alert color="secondary">
                        <strong>
                            {{ totalizadores.totalPacienteAcompanhante - totalizadores.totalPaciente }}
                        </strong>
                    </rkm-alert>
                </rkm-col>

                <rkm-col cols="3">
                    Paciente + Acompanhante
                    <rkm-alert color="secondary">
                        <strong>
                            {{ totalizadores.totalPacienteAcompanhante }}
                        </strong>
                    </rkm-alert>
                </rkm-col>
            </rkm-row>
        </rkm-area>

    </div>
</template>

<script>
import { mapActions } from "vuex";

import { repository, error, data, object, stringCase, file } from "@/mixins";

import moment from "moment";
import Modal from './components/Modal'
import formats from '@/filters/formats'

export default {
    filters: {
        formatDate: formats.formatDate,
        formatCns: formats.formatCns
    },
    components: { Modal },
    props: {
        data: { type: Object },
    },
    computed: {
        optionalColumns() {
            return this.columns.filter(c => !(c.fixed || false))
        },
        fields() {
            return this.columns.filter(c => (c.fixed || false) || this.selectedCols.includes(c.key))
        },
        fieldsPaciente() {

            return {
                paciente: [
                    { key: 'cidadao.nome', searchable: true },
                ],
            }
        },
        validations() {
            return {
                dataInicial: {
                    required: true,
                },
                dataFinal: {
                    required: true,
                },
            }
        }
    },
    created() {
        this.repositories = {
            relatorioViagemGeral: this.getConectaSusRepository("transportePaciente.relatorioViagemGeral"),
            paciente: this.getConectaSusRepository('cadastro.sujeitoAtencao.paciente'),
            impressao: this.getConectaSusRepository('impressao.transportePaciente'),
            exportacao: this.getConectaSusRepository('exportacao.transportePaciente'),
        };
        this.load();
    },
    data() {
        return {
            notBusca: null,
            form: null,
            model: null,
            items: [],
            totalizadores: [],
            indeterminate: true,
            selectedAll: false,
            selectedCols: [
                'data',
                'horario',
                'pacienteNome',
                'destino',
                'status'
            ],
            columns: [
                {
                    key: "data",
                    label: "Data",
                    sortable: true,
                    fixed: true,
                },
                {
                    key: "horario",
                    label: "Horário da consulta",
                    sortable: true,
                    fixed: true,
                },
                {
                    key: "protocolo",
                    label: "Protocolo",
                    fixed: true
                },
                {
                    key: "municipio",
                    label: "Cidade de destino",
                    sortable: true,
                },
                {
                    key: "destino",
                    label: "Local de destino",
                    sortable: true,
                    fixed: true,
                },
                {
                    key: "motivoViagem",
                    label: "Motivo da viagem",
                    sortable: true,
                },
                {
                    key: "observacaoViagem",
                    label: "Observação da viagem"
                },
                {
                    key: "pacienteNome",
                    label: "Paciente",
                    sortable: true,
                    fixed: true,
                },
                {
                    key: "cns",
                    label: "CNS",
                },
                {
                    key: "endereco",
                    label: "Endereço"
                },
                {
                    key: "pontoReferencia",
                    label: "Ponto de referência",
                    sortable: true,
                },
                {
                    key: "acompanhante",
                    label: "Acompanhante",
                    sortable: true,
                },
                {
                    key: "observacaoPaciente",
                    label: "Observação do paciente"
                },
                {
                    key: "veiculo",
                    label: "Veículo",
                    sortable: true,
                },
                {
                    key: "horarioSaida",
                    label: "Horário de saída do veículo",
                    sortable: true,
                },
                {
                    key: "motorista",
                    label: "Motorista",
                    sortable: true,
                },
                {
                    key: "status",
                    label: "Status",
                    sortable: true,
                    fixed: true,
                },
                {
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min',
                    fixed: true
                }
            ]
        };
    },
    methods: {
        ...mapActions(["setLoading", "unsetLoading"]),
        load() {
            this.setLoading();
            this.repositories.relatorioViagemGeral
                .index()
                .then(({ data }) => {
                    if (data.form) this.form = data.form;
                    if (data.model) this.model = data.model;
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading());
        },
        getMotivos() {

            this.notBusca = null

            if(this.model.dataInicial && this.model.dataFinal) {
                this.setLoading()
                this.repositories.relatorioViagemGeral.getMotivos({
                    'data_inicial': moment(this.model.dataInicial).format('Y-M-D'),
                    'data_final': moment(this.model.dataFinal).format('Y-M-D'),
                })
                .then(({data}) => {
                    this.form.motivoViagem = data
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
            }
        },
        getMunicipios() {

            this.notBusca = null

            if(this.model.dataInicial && this.model.dataFinal) {
                this.setLoading()
                this.repositories.relatorioViagemGeral.getMunicipios({
                    'data_inicial': moment(this.model.dataInicial).format('Y-M-D'),
                    'data_final': moment(this.model.dataFinal).format('Y-M-D'),
                    motivo: this.model.motivoViagem,
                })
                .then(({data}) => {
                    this.form.municipio = data
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
            }
        },
        getDestinos() {

            this.notBusca = null

            if(this.model.dataInicial && this.model.dataFinal) {
                this.setLoading()
                this.repositories.relatorioViagemGeral.getDestinos({
                    'data_inicial': moment(this.model.dataInicial).format('Y-M-D'),
                    'data_final': moment(this.model.dataFinal).format('Y-M-D'),
                    motivo: this.model.motivoViagem,
                    municipio: this.model.municipio,
                })
                .then(({data}) => {
                    this.form.destino = data
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
            }
        },
        getVeiculos() {

            this.notBusca = null

            if(this.model.dataInicial && this.model.dataFinal) {
                this.setLoading()
                this.repositories.relatorioViagemGeral.getVeiculos({
                    'data_inicial': moment(this.model.dataInicial).format('Y-M-D'),
                    'data_final': moment(this.model.dataFinal).format('Y-M-D'),
                    motivo: this.model.motivoViagem,
                    municipio: this.model.municipio,
                    destino: this.model.destino,
                })
                .then(({data}) => {
                    this.form.veiculo = data
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
            }
        },
        search() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if(!valid) return
                    this.setLoading()
                    this.repositories.relatorioViagemGeral.list({
                        'data_inicial': moment(this.model.dataInicial).format('Y-M-D'),
                        'data_final': moment(this.model.dataFinal).format('Y-M-D'),
                        motivo: this.model.motivoViagem,
                        municipio: this.model.municipio,
                        destino: this.model.destino,
                        veiculo: this.model.veiculo,
                        paciente: this.model.paciente ? this.model.paciente.id : null,
                        status: this.model.status,
                        protocolo: this.model.protocolo
                    })
                    .then(({data}) => {
                        this.notBusca = data;
                        this.items = data.consulta
                        this.totalizadores = data.totalizadores
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
                })
        },
        reset() {
            this.notBusca = null
            this.model.motivoViagem = null
            this.model.municipio = null
            this.model.destino = null
            this.model.veiculo = null
            this.model.dataInicial = null
            this.model.dataFinal = null
            this.items = []
        },
        print() {
            this.setLoading()
            this.repositories.impressao.relatorioViagemGeral(this.prepareDataWithColumns())
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        exportTo() {
            this.setLoading()
            this.repositories.exportacao.relatorioViagemGeral(this.prepareDataWithColumns())
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        prepareDataWithColumns() {
            const data = this.prepareData()
            data.selectedCols = this.fields.map(f => {
            return {
                    key: this.camelToSnake(f.key),
                    label: f.label,
                    class: f.class
                }
            }).slice(0,-1)
            return data
        },
        prepareData() {
            const data = this.clone(this.model)

            data.data = moment(this.model.data).format('Y-M-D')
            data.dataInicial = moment(this.model.dataInicial).format('Y-M-D')
            data.dataFinal = moment(this.model.dataFinal).format('Y-M-D')

            return this.camelObjectKeysToSnakeRecursive(data)
        },
        selectAll(selected) {

            this.selectedCols = selected ? this.columns.map(c => c.key) : []
        },
    },
    watch: {
        model: {
            deep: true,
            handler() {
                this.itens = []
                this.totalizadores = null
            }
        },
        'model.dataInicial': function() {
            if(this.model.dataFinal) {
                this.getMotivos()
                this.getMunicipios()
                this.getDestinos()
                this.getVeiculos()
            }
        },
        'model.dataFinal': function() {
            if(this.model.dataInicial) {
                this.getMotivos()
                this.getMunicipios()
                this.getDestinos()
                this.getVeiculos()
            }
        },
        'model.motivoViagem': function() {
            this.getMunicipios()
            this.getDestinos()
            this.getVeiculos()
        },
        'model.municipio': function() {
            this.getDestinos()
            this.getVeiculos()
        },
        'model.destino': function() {
            this.getVeiculos()
        },
        selectedCols(newValue) {

            this.selectedAll = newValue.length > 0 && newValue.length == this.columns.length
            this.indeterminate = newValue.length > 0 && newValue.length != this.columns.length
        },
    },
    mixins: [repository, error, data, object, stringCase, file],
};
</script>
